import { supabase } from "@/lib/supabase";

export interface AccessibleTeam {
  teamGroupKey: string;
  teamName: string;
  department: string;
}

export async function fetchAccessibleTeams(department = "sales"): Promise<AccessibleTeam[]> {
  const { data, error } = await supabase.rpc("wh_list_accessible_teams", {
    p_department: department,
  });

  if (error) throw error;

  return (data ?? []).map((row) => ({
    teamGroupKey: row.team_group_key as string,
    teamName: row.team_name as string,
    department: row.department as string,
  }));
}
